import { useQueryParams } from './UseQueryParams';

export const useModalQuery = (queryKey: string) => {
  const modalQueryKey = 'modal';
  const { addQueries, removeQueries, checkIfQueryIsPresent } = useQueryParams();

  const openModal = () => {
    addQueries({ [modalQueryKey]: queryKey });
  };

  const closeModal = () => {
    removeQueries([modalQueryKey]);
  };

  const isModalOpen = checkIfQueryIsPresent(modalQueryKey, queryKey);

  return {
    openModal,
    closeModal,
    isModalOpen,
  };
};
